<template>
    <reconciliation-step-template 
        :nextStep="nextStep" 
        :previousStep="previousStep" 
        @next="goToNextStep"
        @previous="$emit('previous')"
        :loading="loading">
        
        <template slot="content">
        
            <h3>{{ $l10n.__("Libéllé de la transaction") }}</h3>
            <p class="fs-3 semibold mt-4 mb-2">{{ $l10n.__("Vous pouvez définir une ou plusieurs colonnes qui définiront le libellé.") }}</p>
            <div class="step-container-table border-black mt-3" v-loading="loading">
                <table-selectable-columns 
                    :lines="csv"
                    v-model="value.template.label.columns"
                    :max="3"
                />
            </div>
        </template>
    </reconciliation-step-template>
</template>

<script>
    import TableSelectableColumns from 'vcomponents/utilities/TableSelectableColumns.vue'
    import ImportStepsMixins from './ImportStepsMixins'
    import BankReconciliationImport from 'api/bankreconciliationImport'

    export default {
        mixins: [ImportStepsMixins],
        data(){
            return {
                loading: false
            }
        },
        created(){
            this.checkPreviousSteps()
            this.checkLabelColumns()
        },
        methods: {
            goToNextStep(){
                if(this.checkMinColumns('label', 3)){
                    this.loading = true
    
                    BankReconciliationImport.updateTemplate(this.idImport, this.value.template)
                    .then(response => {
                        this.$emit('next')
                    })
                    .catch(error => {
                        Push.error(error.template, false)
                    })
                    .finally(() => {
                        this.loading = false
                    })
                }
            }
        },
        components: {
            TableSelectableColumns
        }
    }
</script>

<style scoped>

</style>
